import { Box, Grid, Tooltip, Typography } from "@mui/material";

const ListProductProposal = ({
  data,
  brand,
  refs,
  maxHeight,
  isTitle = true,
}) => {
  return (
    <Grid container spacing={2} py={{ xs: 1, md: 2 }}>
      <Box
        display={"flex"}
        width={"100%"}
        height={"100%"}
        padding={"12px 36px"}
        overflow={"scroll"}
        sx={{
          "&::-webkit-scrollbar": {
            display: "none",
          },
          "-ms-overflow-style": "none",
          "scrollbar-width": "none",
        }}
      >
        {isTitle && (
          <Grid
            container
            justifyContent={{ xs: "center", md: "center" }}
            textAlign={"end"}
            minWidth={"180px"}
            sx={{
              position: "sticky",
              left: -50,
              backgroundColor: "white",
              zIndex: 1,
              // borderRight: "2px dashed #cbcaca"
            }}
          >
            <Box width={"100%"} padding={"0px 12px"}>
              <Typography
                margin={"48px 0 54px 0px"}
                color={"#626160"}
                fontSize={"12px"}
              >
                Nombre del Plan:
              </Typography>
              <Typography fontSize={"12px"} color={"#626160"}>
                Categoría:
              </Typography>
              <Typography fontSize={"12px"} color={"#626160"}>
                Tipo de Pago:
              </Typography>
              <Typography fontSize={"12px"} color={"#626160"}>
                Vigencia:
              </Typography>
              {/* <Typography
                      margin={"34px 0px"}
                      variant="h5"
                      fontSize={"12px"}
                      color={'#626160'}
                  >
                      Valor Mes Equivalente:
                  </Typography> */}
              <Typography
                margin={"32px 0 34px 0px"}
                fontSize={"12px"}
                color={"#626160"}
              >
                Hoy Pagas:
              </Typography>
              <Typography
                margin={"32px 0 34px 0px"}
                fontSize={"12px"}
                color={"#626160"}
              >
                Meses Incluidos:
              </Typography>
              <Typography fontSize={"12px"} color={"#626160"}>
                Inscripción:
              </Typography>
              <Typography fontSize={"12px"} color={"#626160"}>
                Cuota Mantenimiento:
              </Typography>
              {data[0].months?.length > 0 &&
                data[0].months?.map((item, index) => {
                  return (
                    <Typography fontSize={"12px"} color={"#626160"}>
                      Mes {index + 1}:
                    </Typography>
                  );
                })}
              {/* <Typography fontSize={"12px"} color={'#626160'}>Pago Recurrente:</Typography> */}
              <Typography
                fontSize={"12px"}
                color={"#626160"}
                marginTop={"24px"}
              >
                Frecuencia de Pago:
              </Typography>
              <Typography
                color={"#626160"}
                fontSize={"12px"}
                margin={"34px 0px"}
              >
                Valor del Plan:
              </Typography>
              <Typography
                color={"#626160"}
                fontSize={"12px"}
                margin={"34px 0px"}
              >
                Valor del Mes:
              </Typography>
              <Typography
                minHeight={maxHeight}
                fontSize={"12px"}
                margin={"24px 0px"}
                color={"#626160"}
              >
                Descripción Descuentos:
              </Typography>
              <Typography
                fontSize={"12px"}
                color={"#626160"}
                marginBottom={"24px"}
              >
                Permanencia:
              </Typography>
              <Typography fontSize={"12px"} color={"#626160"}>
                Condiciones del Plan:
              </Typography>
            </Box>
          </Grid>
        )}
        {data?.length > 0 &&
          data.map((item, index) => {
            return (
              <Grid
                xs={3}
                container
                justifyContent={{ xs: "center", md: "flex-start" }}
                style={{
                  borderLeft: isTitle && "2px dashed #787777",
                  borderRight: !isTitle && "2px dashed #787777",
                }}
                width={"330px"}
                minWidth={"220px"}
              >
                <Box width={"100%"} padding={"0px 12px"}>
                  <Typography textAlign={"center"}>
                    Opción {index + 1}
                  </Typography>
                  <Tooltip title={item.product_name} arrow placement="top">
                    <Typography
                      margin={"24px 0px"}
                      variant="h5"
                      fontSize={"16px"}
                      sx={{
                        lineHeight: "1.5",
                        maxHeight: "3em",
                        minHeight: "3em",
                        overflow: "hidden",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2,
                        textOverflow: "ellipsis",
                      }}
                    >
                      {item.product_name}
                    </Typography>
                  </Tooltip>

                  <Typography fontSize={"12px"}>{item.category}</Typography>
                  <Typography fontSize={"12px"}>{item.payment_type}</Typography>
                  <Typography fontSize={"12px"}>{item.validity}</Typography>
                  {/*<Box
              width={"100%"}
              backgroundColor={"#EAEAEA"}
              borderRadius={"4px"}
              margin={"24px 0px"}
              padding={"6px 0px"}
            >
              <Typography
                textAlign={"center"}
                variant="h5"
                fontSize={"16px"}
              >
                {item.value_plan}
              </Typography>
            </Box>*/}
                  <Box
                    width={"100%"}
                    backgroundColor={brand.background}
                    borderRadius={"4px"}
                    margin={"24px 0px"}
                    padding={"8px 0px"}
                  >
                    <Typography
                      textAlign={"center"}
                      variant="h5"
                      fontSize={"16px"}
                      color={brand.color}
                    >
                      {item.today_pay}
                    </Typography>
                  </Box>

                  <Box
                    width={"100%"}
                    borderRadius={"4px"}
                    margin={"24px 0px"}
                    padding={"6px 0px"}
                  >
                    <Typography fontSize={"12px"}>{item.months_included}</Typography>
                  </Box>

                  <Typography fontSize={"12px"}>{item.inscription}</Typography>
                  <Typography fontSize={"12px"}>
                    {item.maintenance_cuot}
                  </Typography>
                  {item.months?.length > 0 &&
                    item.months.map((item, index) => {
                      return <Typography fontSize={"12px"}>{item}</Typography>;
                    })}
                  {/* <Typography fontSize={"12px"}>
              {item.payment_type == "Pago Recurrente"
                ? item.value_plan
                : "-"}
            </Typography> */}
                  <Typography fontSize={"12px"} marginTop={"24px"}>
                    {item.frecuency_payment}
                  </Typography>
                  <Box
                    width={"100%"}
                    backgroundColor={"#EAEAEA"}
                    borderRadius={"4px"}
                    margin={"24px 0px"}
                    padding={"6px 0px"}
                  >
                    <Typography
                      textAlign={"center"}
                      variant="h5"
                      fontSize={"16px"}
                    >
                      {item.value_plan}
                    </Typography>
                  </Box>
                  <Box
                    width={"100%"}
                    borderRadius={"4px"}
                    margin={"24px 0px"}
                    padding={"6px 0px"}
                  >
                    <Typography fontSize={"12px"}>{item.value_of_the_month}</Typography>
                  </Box>
                  <Typography
                    fontSize={"16px"}
                    variant="h5"
                    margin={"26px 0px"}
                    dangerouslySetInnerHTML={{
                      __html: item.discount_descriptions,
                    }}
                    ref={(el) => (refs.current[index] = el)}
                    sx={{ minHeight: maxHeight ? `${maxHeight}px` : "auto" }}
                  />
                  <Typography fontSize={"12px"} marginBottom={"24px"}>
                    {item.permanence}
                  </Typography>
                  <Typography
                    fontSize={"12px"}
                    dangerouslySetInnerHTML={{
                      __html: item.product_description,
                    }}
                    maxHeight={"250px"}
                    overflow={"scroll"}
                    sx={{
                      "&::-webkit-scrollbar": {
                        display: "none",
                      },
                      "-ms-overflow-style": "none",
                      "scrollbar-width": "none",
                    }}
                  />
                </Box>
              </Grid>
            );
          })}
      </Box>
    </Grid>
  );
};

export default ListProductProposal;
